<template>
    <div class="g-table-wrapper">
        <div class="table-title">
            <d-tooltip placement="left" identifier="projects.projectTypeRevenue" />
            {{ title }}
        </div>
        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="searchOptions"
            :pagination-options="paginationOptions"
            :sort-options="sortOptions"
            :styleClass="styleClass"
            v-if="rows.length > 0 || $store.state.closedRows && $store.state.closedRows.length === 0"
            @on-row-click="selectProjectType"
            :row-style-class="selectedRowClass">
        >
            <div slot="emptystate">
                Ingen data ...
            </div>
            <template slot="table-row" slot-scope="props">
                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                    {{ props.row.coverage_percent | rounded }} 
                    <div
                        v-if="props.row.coverage_percent !== null"
                        class="coverage-indicator"
                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                    />
                </div>
                <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;">
                    {{ props.row.case_number }}
                </div>
                <div v-else-if="props.column.field == 'description'" :title="props.row.description">
                    {{ props.row.description | truncate }}
                </div>
                <div v-else-if="props.column.field == 'invoices_total'">
                    {{ props.row.invoices_total | currency }}
                </div>
                <div v-else-if="props.column.field == 'coverage'">
                    {{ props.row.coverage | currency }}
                </div>
                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                    {{ props.row.coverage_per_hour | currency }} 
                    <div
                        v-if="props.row.coverage_per_hour !== null"
                        class="coverage-indicator"
                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                    />
                </div>
                <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                    <i class="fad fa-eye" />
                </div>
                <div v-else-if="props.column.field == 'start_date'">
                    {{ props.row.start_date | moment("DD. MMM YYYY") }}
                </div>
                <div v-else-if="props.column.field == 'type'" class="table-column__description" :title="props.row.type ? props.row.type : '-'">
                    {{ props.row.type ? props.row.type : '-' }}
                </div>
                <div v-else :title="props.formattedRow[props.column.field]">
                    {{ props.formattedRow[props.column.field] }}
                </div>
            </template>
        </vue-good-table>   

        <box-loading height="350" v-else />
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: [
        'title'
    ],
    data () {
        return {
            selectedProjectType: null,
            columns: [
                { label: 'Opgavetype', field: 'type', type: 'string' },
                { label: 'Antal', field: 'count', type: 'number' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }
                // { label: 'Gns oms', field: 'avgRevenue', type: 'number' }
                // { label: '', field: 'action', width: '5%', type: 'string', filterable: false }
            ],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    computed: {
        closedRows () {
            return this.$store.state.closedRows
        }
    },
    watch: {
        closedRows: function () {
            this.rows = []
            this.$emit('finishedLoading', null)
            if (this.closedRows && this.closedRows.length) {
                this.calculateData()
            } else {
                this.$emit('finishedLoading', 0)
            }
        }
    },
    methods: {
        selectedRowClass (row) {
            if (row.type === this.selectedProjectType) {
                return 'selected'
            }
        },
        selectProjectType (params) {
            this.selectedProjectType = params.row.type
            this.$emit('selectProjectType', params.row.type)
        },
        openExternalLink (id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu')
            // window.open('LINKHERE', '_blank')
        },
        calculateData () {
            this.rows = []
            let groupedProjects = this.$store.getters.groupedProjects
            // console.log(groupedProjects)
            Object.keys(groupedProjects).forEach(projectType => {
                // Laver array med alle invoices_total
                let invoicesTotalArray = groupedProjects[projectType].map(project => {
                    return Math.round(project.invoices_total)
                })
                // Summerer alle invoices_total
                let summedInvoicesTotal = _.reduce(invoicesTotalArray, (sum, invoicesTotal) => {
                    return sum + invoicesTotal
                })
                // Laver array med alle DB
                let coverageArray = groupedProjects[projectType].map(project => {
                    return Math.round(project.coverage)
                })
                // Summerer alle DB
                let summedCoverage = _.reduce(coverageArray, (sum, coverage) => {
                    return sum + coverage
                })
                // Laver array med alle timelog total
                let timelogArray = groupedProjects[projectType].map(project => {
                    return Math.round(project.timelog_hours)
                })
                // Summerer alle timelog total
                let summedTimelogTotal = _.reduce(timelogArray, (sum, timelogHours) => {
                    return sum + timelogHours
                })
                // Laver array med alle DG og DB/time, der ikke er 0
                let coveragePercentArray = []
                let coveragePerHourArray = []
                groupedProjects[projectType].forEach(project => {
                    if (project.coverage_percent) {
                        coveragePercentArray.push(Math.round(project.coverage_percent))
                    }
                    if (project.coverage_per_hour) {
                        coveragePerHourArray.push(project.coverage_per_hour)
                    }
                })
                // Beregner gennemsnit af DG- og DB/time-arrays
                let averageCoveragePercent = _.mean(coveragePercentArray)
                let averageCoveragePerHour = _.mean(coveragePerHourArray)
                // Bygger object med alle 3 værdier
                let item = {
                    type: projectType,
                    count: groupedProjects[projectType].length,
                    invoices_total: summedInvoicesTotal,
                    coverage: summedCoverage,
                    coverage_percent_avg: Math.round(averageCoveragePercent),
                    coverage_percent: Math.round((summedCoverage / summedInvoicesTotal) * 100),
                    coverage_per_hour_avg: Math.round(averageCoveragePerHour),
                    coverage_per_hour: summedTimelogTotal > 0 && summedCoverage > 0 ? Math.round(summedCoverage / summedTimelogTotal) : 0
                    // avgRevenue: summedInvoicesTotal / groupedProjects[projectType].length
                }
                this.rows.push(item)
            })
            this.$emit('finishedLoading', this.rows.length)
        }
    }
}
</script>



// WEBPACK FOOTER //
// typesRevenue.vue?e838859c